import { render } from "./BovineCard.vue?vue&type=template&id=01424566&scoped=true"
import script from "./BovineCard.vue?vue&type=script&lang=js"
export * from "./BovineCard.vue?vue&type=script&lang=js"

import "./BovineCard.vue?vue&type=style&index=0&id=01424566&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01424566"]])

export default __exports__